import React, { useState } from 'react';
import {
  Box,
  Button,
  Circle,
  Flex,
  Heading,
  Image,
  Text,
} from '@chakra-ui/react';
import { AiFillCaretLeft, AiFillCaretRight } from 'react-icons/ai';
import { sliderItems } from '../data';

export default function Slider() {
  const [slideIndex, setSlideIndex] = useState(0);
  const handleClick = direction => {
    if (direction === 'left') {
      setSlideIndex(slideIndex > 0 ? slideIndex - 1 : 2);
    } else {
      setSlideIndex(slideIndex < 2 ? slideIndex + 1 : 0);
    }
  };
  return (
    <Flex
      maxW="1400px"
      m="auto"
      h="84vh"
      display={['none', 'none', 'none', 'flex']}
      position="relative"
      overflow={'hidden'}
    >
      <Flex w="full" position={'absolute'} height="100%">
        <Circle
          onClick={() => handleClick('left')}
          zIndex={3}
          transition="transform 0.5s ease"
          _hover={{
            transform: 'scale(1.1)',
          }}
          color="white"
          fontSize={'20px'}
          alignSelf={'center'}
          bg="teal"
          p="3"
          ml="5"
        >
          <AiFillCaretLeft />
        </Circle>
        <Circle
          onClick={() => handleClick('right')}
          zIndex={3}
          transition="transform 0.5s ease"
          _hover={{
            transform: 'scale(1.1)',
          }}
          color="white"
          fontSize={'20px'}
          alignSelf={'center'}
          p="3"
          bg="teal"
          ml="auto"
          mr="5"
        >
          <AiFillCaretRight />
        </Circle>
      </Flex>

      <Flex
        h="100%"
        transition="all 1.5s ease"
        transform={`translateX(${slideIndex * -100}vw)`}
      >
        {sliderItems.map(item => (
          <Flex
            w="100vw"
            h="full"
            alignItems="center"
            key={item.id}
            bg={item.bg}
          >
            <Flex alignItems="center" flex="1" h="full" m="0 80px">
              <Image h="90%" src={item.img} objectFit="contain" />
            </Flex>
            <Box flex="1" p="50px">
              <Heading as="h1" fontSize="6xl">
                {item.title}
              </Heading>
              <Text
                as="p"
                fontFamily="raleway"
                fontSize="20px"
                letterSpacing={'3px'}
                m="10px 0px"
                fontWeight={500}
              >
                {item.desc}
              </Text>
              <Button
                p="10px"
                fontSize={'20px'}
                cursor="pointer"
                colorScheme={'teal'}
              >
                Shop Now
              </Button>
            </Box>
          </Flex>
        ))}
      </Flex>
    </Flex>
  );
}
